<footer class="app-footer">
  <div class="app-footer__left">
    <span class="app-footer__brand">AHA &mdash; Agentic Harmonization Assistant</span>
    <span class="app-footer__powered">powered by IGC Pharma</span>
  </div>
  <div class="app-footer__right">
    <span class="app-footer__cta">New to AHA?</span>
    <a class="app-footer__pill" href="https://harmonize-aha.com" target="_blank" rel="noopener noreferrer">
      <span class="material-icons-outlined app-footer__pill-icon">language</span>
      <span class="app-footer__pill-url">harmonize-aha.com</span>
    </a>
  </div>
</footer>
